import script from "./BlockAccount.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockAccount.vue?vue&type=script&setup=true&lang=js"

import "./BlockAccount.vue?vue&type=style&index=0&id=80219cc4&lang=css"

const __exports__ = script;

export default __exports__